import { render, staticRenderFns } from "./navBox.vue?vue&type=template&id=e6cf2732&scoped=true"
import script from "./navBox.vue?vue&type=script&lang=js"
export * from "./navBox.vue?vue&type=script&lang=js"
import style0 from "./navBox.vue?vue&type=style&index=0&id=e6cf2732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cf2732",
  null
  
)

export default component.exports